import React from 'react';
import { config } from '../../../Configurations';
import { generateSlugLink } from '../../../Utils';
import { SearchUserWrap, SearchUserIcon, SearchUserIconWrap, SearchUserName } from './style';
import { Icon } from '../../Components/Icons/Icons';
import { HoverableLink } from '../../Layouts';

const SearchUser = props => {
    let imageUrl = null;

    if (props.smallImage) {
        const domain = config.baseUrl;
        imageUrl = `${domain}${props.smallImage}`;
    }

    const urlOption = {
        name: props.fullName,
        id: props.id,
    };

    const getImage = imageUrl => (imageUrl ? <SearchUserIcon url={imageUrl} /> : <Icon.SearchUserDefaultImage />);

    const handleClose = () => props.handleClose();

    return (
        <SearchUserWrap onClick={handleClose}>
            <HoverableLink to={`/${generateSlugLink(urlOption)}`}>
                <SearchUserIconWrap>{getImage(imageUrl)}</SearchUserIconWrap>
                <SearchUserName>{props.fullName}</SearchUserName>
            </HoverableLink>
        </SearchUserWrap>
    );
};

export default SearchUser;



// WEBPACK FOOTER //
// ./src/UI/Containers/Search/SearchUser.js